<template>
  <PDF :url="url" />
</template>

<script>
import PDF from '@/components/pdf/pdf'

export default {
  name: 'PreviewPDF',
  props: {
    id: String,
  },
  data() {
    return {
      url: '',
    }
  },
  components: {
    PDF,
  },
  created() {
    if (this.id.includes('.pdf')) {
      this.url = this.id
    } else {
      this.url = `/zcjf/base/file/download/${this.id}`
    }
  },
}
</script>
